var _circle, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWalletconnect(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "url(#paint0_linear_455_13921_walletconnect)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.775 7.297c2.334-2.273 6.116-2.273 8.452 0l.281.273a.284.284 0 0 1 0 .41l-.96.937a.152.152 0 0 1-.211 0l-.386-.375c-1.627-1.585-4.269-1.585-5.896 0l-.413.402a.152.152 0 0 1-.212 0l-.963-.936a.284.284 0 0 1 0-.411l.308-.3ZM16.214 9.23l.854.831a.284.284 0 0 1 0 .411l-3.855 3.755a.304.304 0 0 1-.422 0l-2.738-2.665a.079.079 0 0 0-.106 0l-2.735 2.665a.304.304 0 0 1-.422 0l-3.858-3.752a.284.284 0 0 1 0-.411l.854-.831a.304.304 0 0 1 .423 0l2.738 2.665c.03.027.075.027.105 0l2.735-2.665a.304.304 0 0 1 .423 0l2.738 2.665c.03.027.075.027.105 0l2.738-2.665a.3.3 0 0 1 .423-.003Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_455_13921_walletconnect",
    x1: 17.962,
    x2: 1.564,
    y1: 15.355,
    y2: 4.502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E73F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6395E6"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletconnect);
export default __webpack_public_path__ + "static/media/walletconnect.2c8d6e7154821121548721ae9d8a371e.svg";
export { ForwardRef as ReactComponent };